import { format } from 'date-fns';

export const getFormattedDate = (createdTime: string, updatedTime: string, dateFormat?: string) => {
  return `${format(createdTime, dateFormat?.slice(0, -2) || '')} - ${format(
    updatedTime,
    dateFormat?.slice(0, -2) || '',
  )}`;
};
